module.exports = __webpack_public_path__ + "static/media/ic_instant_withdrawal.fb24b301.svg";